// extracted by mini-css-extract-plugin
export var dateUpdated = "DateUpdated-module--date-updated--a322a";
export var dateUpdatedIcon = "DateUpdated-module--date-updated-icon--01a52";
export var dateUpdatedText = "DateUpdated-module--date-updated-text--74538";